import { ChallengeType } from 'features/auth/resetPassword/constants/ChallengeType';
import VerifyAddressChangeScreen from 'features/otp/challenges/VerifyAddressChangeScreen/VerifyAddressChangeScreen';
import React from 'react';

export default function Page() {
  return <VerifyAddressChangeScreen otpChallengeType={ChallengeType.Email} />;
}
